module.exports = __webpack_public_path__ + "img/pic01.11dc0712.png";